'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

OrganizationDefaultsService=class OrganizationDefaultsService extends BaseService{
static get $inject(){return['socketService']}

constructor(socketService){
super();
this._socketService=socketService;
}

async getOrganizationThresholds(socketOptions){
return await this._getOrganizationDefaults(socketOptions);
}

async getFullOrganizationDefaults(socketOptions){
return await this._getOrganizationDefaults(socketOptions,{includeOrgVisibilitySetting:!0});
}

async _getOrganizationDefaults(socketOptions,body){
let response=await this._socketService.sendAndWaitForResponse('GetOrganizationDefaultThresholds',body,socketOptions);
if(!SocketResponse.succeeded(response)){
throw new Error('Unexpected error getting organization defaults.');
}
return response.body;
}

async setOrganizationThresholds(fatigueThreshold,deviationThreshold){
let response=await this._socketService.sendAndWaitForResponse('SetOrganizationDefaultThresholds',{fatigueThreshold,deviationThreshold});
if(!SocketResponse.succeeded(response)){
throw new Error('Unexpected error setting organization defaults.');
}
return response.body;
}};


module.exports=OrganizationDefaultsService;
//# sourceMappingURL=organizationDefaultsService.js.map
